import socketIOClient from 'socket.io-client';
import { handleSessionExpired } from '../http';

const ENDPOINT = process.env.REACT_APP_baseUrl;

export const attachSessionExpireListener = (socket) => {
  socket.on('session-expire', () => {
    handleSessionExpired();
  });
  return socket;
};

export const createAuthenticatedSocket = (jwtToken) => {
  if (!jwtToken) {
    return null;
  }

  return attachSessionExpireListener(
    socketIOClient(ENDPOINT, {
      query: { authorization: jwtToken },
    })
  );
};

const socket = createAuthenticatedSocket(localStorage.getItem('jwtToken'));

export default socket;
